<template>
  <smsquick-card title="SMS">
    <template v-slot:header-actions>
      <span>{{sms_balance?sms_balance+" sms remaining":""}} </span>
    </template>
    <template v-slot:card-content>
        <v-layout row wrap>

            <v-flex xs12>
                <v-text-field label="API Key" v-model="sms_model.apiKey"/>
            </v-flex>
            <v-flex xs12>
                <v-text-field label="Sender ID" v-model="sms_model.senderid"/>
            </v-flex>

            <v-btn class="success" @click="savesetting()" :loading="loading">Save</v-btn>
        </v-layout>
    </template>
  </smsquick-card>
</template>

<script>
import smsService from '~/services/sms'
import QuickCard from "../Quickcard";
import { mapGetters } from "vuex";
export default {
  name: "sms-settings",
  components: {
    "smsquick-card": QuickCard
  },
  data(){
    return{
      sms_model:{
        apiKey:'',
        senderid:'',
      },
      sms_modelcp:{
        apiKey:'',
        senderid:'',
      },

    }
  },
   created() {
    this.$store.dispatch("settings/getAll")
    this.$store.dispatch("sms/getBalance")
  },
  computed: {
    ...mapGetters({
      settings: "settings/SETTINGS",
      seterrors: "settings/SETTING_ERROR",
      loading: "settings/SETTING_LOADING",

      sms_balance: "sms/SMS_BALANCE",
      serrors: "sms/SMS_ERROR",
      sloading: "sms/SMS_LOADING",

    })
  },
  methods: {
      async savesetting() {
        try {
          await this.$store.dispatch("settings/add", this.sms_model);

          if (this.seterrors == null) {
            this.sms_modelcp = { ...this.sms_model };
            this.$store.dispatch("sms/getBalance");
            this.$store.dispatch("responseMessage", {
              type: "success",
              text: "Settings saved successfully.",
              title: "Save Settings",
              modal: false
            });
          } else {
            this.sms_model = { ...this.sms_modelcp };
            this.$store.dispatch("responseMessage", {
              type: "warning",
              text: "Sorry settings could not be saved.",
              title: "Save Settings",
              modal: false
            });
          }
        } catch (e) {
          this.sms_model = { ...this.sms_modelcp };
          this.$store.dispatch("responseMessage", {
            type: "warning",
            text: "Sorry settings could not be saved.",
            title: "Save Settings",
            modal: false
          });
        }
      },

  },
  watch:{
    settings(val){

       if (this.seterrors==null && this.settings.sms) {
        this.sms_model = this.settings.sms;
        this.sms_modelcp = { ...this.settings.sms };
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/sms.vue